import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { GetIconByName } from "../../../../config/icon";
import { closeHomeAdModal } from "../../../console/redux/actions";
import "./styles.scss";

const Index = ({ onAdInfo }) => {
  const adUrl = process.env.REACT_APP_HOME_SIDE_CENTER_ADV; // should be your invoke.js URL
  const dispatch = useDispatch();
  const adContainerRef = useRef(null);

  const [countdown, setCountdown] = useState(10);
  const [showClose, setShowClose] = useState(false);

  useEffect(() => {
    // 1. Setup global ad config
    window.atOptions = {
      key: "e6d047f348d599092cd096ebe8a56ec9",
      format: "iframe",
      height: 90,
      width: 728,
      params: {},
    };

    // 2. Create script element
    const script = document.createElement("script");
    script.type = "text/javascript";
    // script.src = adUrl; // <-- value from .env (invoke.js link)
    script.src =
      "https://www.profitabledisplaynetwork.com/e6d047f348d599092cd096ebe8a56ec9/invoke.js"; // hardcoded for now

    // 3. Inject into container
    if (adContainerRef.current) {
      adContainerRef.current.innerHTML = ""; // clear old ads
      adContainerRef.current.appendChild(script);
    }

    // 4. Cleanup on unmount
    return () => {
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = "";
      }
    };
  }, [adUrl]);

  useEffect(() => {
    const handleMessage = (event) => {
      console.log("Received:", event.data);

      if (event.data?.type === "AD_INFO") {
        onAdInfo(event.data.payload);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, [onAdInfo]);

  // countdown
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setShowClose(true);
    }
  }, [countdown]);

  const handleClose = () => {
    dispatch(closeHomeAdModal());
  };

  return (
    <div className="right-ad active" style={{ position: "relative" }}>
      {/* Timer / Close button */}
      <div
        style={{
          position: "absolute",
          top: "3px",
          left: "3px",
          background: "#ffffff",
          color: "#ff1010",
          fontWeight: "bold",
          padding: "8px",
          fontSize: "12px",
          zIndex: 10,
          cursor: showClose ? "pointer" : "default",
          border: "1px solid #c40b4a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={showClose ? handleClose : undefined}
      >
        {showClose ? (
          <span
            style={{ fontSize: "12px", color: "#ff1010", fontWeight: "bold" }}
          >
            {GetIconByName("cross", "#ff1010")}
          </span>
        ) : (
          `00:${countdown < 10 ? `0${countdown}` : countdown}`
        )}
      </div>
      {/* Ad container (script will render into this div) */}
      <div
        ref={adContainerRef}
        style={{
          width: "100%",
          height: "auto",
          border: "none",
          display: "block",
        }}
      />
      <iframe
        ref={adContainerRef}
        title="Advertisement"
        src={adUrl}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        loading="lazy"
        sandbox="allow-scripts allow-same-origin allow-popups" // Optional
      />
    </div>
  );
};

export default Index;
